import { useLanguage } from "@/hooks/useLanguage";
import { getWcCampaign } from "@/lib/branding/slogan";

interface Props {
  className?: string;
  size?: "xs" | "sm" | "md";
  withProduct?: boolean;
  align?: "left" | "center";
}

const SIZE: Record<NonNullable<Props["size"]>, string> = {
  xs: "text-[10px]",
  sm: "text-xs",
  md: "text-sm",
};

/**
 * World Cup campaign tagline — "Donde el Mundial cobra vida."
 * Cinematic, minimal. Use only in hype / cinematic / export surfaces.
 */
export function WorldCupTagline({
  className = "",
  size = "xs",
  withProduct = false,
  align = "center",
}: Props) {
  const { lang } = useLanguage();
  const text = getWcCampaign(lang);
  const alignCls = align === "center" ? "text-center" : "text-left";
  return (
    <p
      className={`font-medium tracking-[0.18em] uppercase text-muted-foreground/80 ${SIZE[size]} ${alignCls} ${className}`}
      data-wc-campaign
    >
      {withProduct && (
        <span className="mr-2 font-black tracking-normal normal-case text-foreground">
          VerseSport
        </span>
      )}
      <span className="italic opacity-90">{text}</span>
    </p>
  );
}